import React, { useState, useEffect } from "react";
import "./PaymentPage.css";
import sallyImg from "../img/Saly-38.png";
import { useGetPlans, usePaySubscription } from "../hooks/payment";
import LogoutIcon from "@mui/icons-material/Logout";
import { useLogout } from "../hooks/auth";

function PaymentPage() {
  const { loading, plans } = useGetPlans();
  const { isLoaidingCheckoutPage, handlePay } = usePaySubscription();
  const { logout } = useLogout();
  // useEffect(() => {
  //   fetch("https://api.quotable.io/random?tags=business")
  //     .then((response) => response.json())
  //     .then((data) => setQuote(data.content))
  //     .catch((error) => console.log(error));
  // }, []);

  if (loading) return <h2 className="text-lg">Loading...</h2>;
  return (
    <div className="sub-wrapper !bg-[rgba(255, 0, 0, 0)]" id="pricing">
      <h1>Our Plan</h1>

      <div className="sub-card-container">
        <div className="subscription-card text-gray-300">
          <h3 className="text-gray-100">Small company</h3>
          <ul className="pricing-features">
            <li>
              <strong className="text-gray-100">500</strong> queries/month
            </li>
            <li>Email assistance</li>
            <li>1 website integration</li>
          </ul>
          <p className="price">$0</p>
          <p className="text-[12px]">
            then {plans[1]?.metadata?.Price} per month
          </p>
          <button onClick={() => handlePay(plans[0])} className="btn">
            Try this plan
          </button>
        </div>

        <div className="subscription-card special-card text-gray-300">
          <h3 className="text-gray-100">Medium Company</h3>
          <ul className="pricing-features">
            <li>
              <strong className="text-gray-100">1000</strong> queries/month
            </li>
            <li>Email assistant</li>
            <li>2 websites integrations</li>
          </ul>
          <p className="price text-gray-100">
            {plans[0]?.metadata?.Price} / month
          </p>
          <button
            className="btn"
            style={{
              background: "rgb(26, 178, 82)",
              boxShadow: "0 0 10px 1px rgb(26, 178, 82)",
            }}
            onClick={() => handlePay(plans[1])}
          >
            Choose this plan
          </button>
        </div>

        <div className="subscription-card text-gray-300">
          <h3 className="text-gray-100">Enterprise</h3>
          <ul className="pricing-features">
            <li>
              <strong className="text-gray-100">100.000</strong> queries/month
            </li>
            <li>Email assistant</li>
            <li>5 websites integrations</li>
          </ul>
          <p className="price text-gray-100">
            {plans[2]?.metadata?.Price} / month
          </p>
          <button onClick={() => handlePay(plans[2])} className="btn">
            Choose this plan
          </button>
        </div>
      </div>
    </div>
  );
}

export default PaymentPage;
